module.exports = __webpack_public_path__ + "static/media/help.465b0876.jpg";